<template>
  <div>
    <el-row class="title-bar" type="flex" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
      <div>
        <w-perf-analysis-time-info v-if="!operationFlag" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataLoad"/>
        <el-radio-group v-model="selectType" style="margin-left: 10px;">
          <el-radio :label="'task'">작업 정보</el-radio>
          <el-radio :label="'event'">이벤트 정보</el-radio>
          <el-radio :label="'alarm'">경보</el-radio>
        </el-radio-group>
      </div>
      <span>
        <el-button class="mr-l4" size="small" @click="onClickConfirmButton" :disabled="checkedRows.length === 0">확인</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </span>
    </el-row>
    <w-vmware-task-table v-show="selectType === 'task'" ref="task" :active="taskActive" :time-param="timeParam" :show-search-tool="showSearchTool" :checked-rows="checkedRows" @selection-change="onSelectionChange"/>
    <w-vmware-event-table v-show="selectType === 'event'" ref="event" :active="eventActive" :time-param="timeParam" :show-search-tool="showSearchTool" :checked-rows="checkedRows"  @selection-change="onSelectionChange"/>
    <w-vmware-alarm-table v-show="selectType === 'alarm'" ref="alarm" :active="alarmActive" :time-param="timeParam" :show-search-tool="showSearchTool" :checked-rows="checkedRows"  @selection-change="onSelectionChange"/>
  </div>
</template>

<script>
import moment from 'moment';
import isNil from 'lodash/isNil';
import { mapGetters } from 'vuex';
import LogAPI from '@/api/log/common';
import msgUtils from '@/utils/message';
import AnalysisTable from '@/mixins/performance/analysis-table';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import WVmwareTaskTable from '@/views/performance/components/virtual/VmwareTaskTable';
import WVmwareEventTable from '@/views/performance/components/virtual/VmwareEventTable';
import WVmwareAlarmTable from '@/views/performance/components/virtual/VmwareAlarmTable';

export default {
  name: 'WVcenterLogView',
  components: {
    WPerfAnalysisTimeInfo,
    WVmwareTaskTable,
    WVmwareEventTable,
    WVmwareAlarmTable,
  },
  mixins: [AnalysisTable],
  props: {
    active: {
      type: Boolean,
    },
    activeTab: {
      type: String,
    },
    timeType: {
      type: String,
    },
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectType: 'task',
      checkDatetime: null,
      timeParam: {},
      showSearchTool: false,
      checkedRows: [],
    };
  },
  computed: {
    taskActive() {
      return this.active && this.selectType === 'task';
    },
    eventActive() {
      return this.active && this.selectType === 'event';
    },
    alarmActive() {
      return this.active && this.selectType === 'alarm';
    },
    ...mapGetters(['plotLineDatetime']),
  },
  watch: {
    timeType: {
      handler() {
        if (!isNil(this.timeType)) {
          this.convertDateType = this.timeType;
          if (this.operationFlag) {
            this.setTimeParams();
          }
        }
      },
      immediate: true,
    },
    plotLineDatetime() {
      this.changeTableData();
      this.setTimeParams();
    },
    activeTab() {
      if (this.activeTab === 'vcenterlog') {
        this.setTimeParams();
      }
    },
    selectType() {
      this.checkedRows = [];
    },
    timeParam: {
      handler() {
        const logTable = this.$refs[this.selectType];
        if (logTable === undefined) {
          this.$nextTick(() => {
            logTable.loadStore(this.timeParam);
          });
        } else {
          logTable.loadStore(this.timeParam);
        }
      },
    },
    immediate: true,
  },
  // create() {
  //   this.changeTableData();
  //   this.setTimeParams();
  // },
  methods: {
    changeTableData() {
      this.checkDatetime = this.plotLineDatetime;
    },
    setTimeParams() {
      const timeList = this.getAnalysisTabTime(this.convertDateType);
      if (!isNil(timeList)) {
        this.timeParam = {
          startDatetime: timeList.startDatetime,
          endDatetime: timeList.endDatetime,
        };
      }
    },
    getAnalysisTabTime(timeType) {
      const timeList = {};
      switch (timeType) {
        case 'hist': {
          timeList.endDatetime = this.plotLineDatetime;
          timeList.startDatetime = moment(new Date(this.plotLineDatetime)).subtract(24, 'hours').toDate().getTime();
          break;
        }
        case 'current': {
          timeList.endDatetime = new Date().getTime();
          timeList.startDatetime = moment(new Date(timeList.endDatetime)).subtract(24, 'hours').toDate().getTime();
          break;
        }
        default:
          break;
      }
      if (!timeList.endDatetime) {
        return null;
      }
      return timeList;
    },
    onTimeTypeChange(value) {
      this.$emit('time-type-change', value);
      this.convertDateType = value;
      this.setTimeParams();
    },
    onCurrentDataLoad() {
      this.changeTableData();
      this.setTimeParams();
    },
    onClickConfirmButton() {
      const params = this.checkedRows;
      LogAPI.updateLogIsChecked(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.CHECK, '로그', response.data.success));
          setTimeout(() => {
            this.$refs[this.selectType].loadStore();
          }, 1500);
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.CHECK, '로그', response.data.success));
        }
      });
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/virtual/components/VcenterLogView.vue